export const blogs = [
 {
    id: 101,
    gameId: 1, 
    title: "🦾 CyberStrike 2077 : Le renouveau du RPG Cyberpunk",
    date: "9 Mars 2026",
    author: "Mamadou Ly",
    category: "Analyse / Test",
    image: "/images/blogs/cyberstrike/cs1.png", 
    intro: "Il semble que c'était hier. En 2026, trois ans après l'arrivée de la mise à jour 2.0 et de l'extension Phantom Liberty, le rêve cyberpunk de CD PROJEKT RED est enfin une réalité stable et immersive. Voici comment Night City s'est réveillée.",
    sections: [
      {
        subtitle: "🏙️ Night City se dévoile",
        text: "Ce n'était pas un simple correctif ; c'était un renouveau. Le jeu que nous avons aujourd'hui est l'aboutissement d'années d'efforts et d'une refonte complète de ses fondations. V contemple désormais une métropole au crépuscule plus vivante que jamais.",
        sectionImage: "/images/blogs/cyberstrike/cs1.png",
        imageCaption: "Image 1 : Night City se dévoile - V contemple la métropole au crépuscule."
      },
      {
        subtitle: "📈 Un Succès Pharaonique en Chiffres",
        text: "Le succès ne s'est pas essoufflé. Avec 35 millions d'exemplaires vendus fin 2025, le jeu a prouvé sa longévité. Plus d'un milliard d'heures ont été passées à explorer les ruelles de Watson ou infiltrer Dogtown. V a été un mercenaire occupé avec plus de 500 millions d'activités complétées.",
        sectionImage: "/images/blogs/cyberstrike/cs2.png",
        imageCaption: "Image 2 : Infographie - Un succès pharaonique en chiffres qui confirme l'adhésion de la communauté."
      },
      {
        subtitle: "🦾 Ce qui a rendu l’aventure inoubliable",
        text: "L'Exploration Urbaine Verticale entre Dogtown et les Hauts Ciels procure toujours le même frisson. Passer des ruelles crasseuses aux sommets vertigineux en un seul vol de AV est une expérience unique que nous avons voulu immortaliser.",
        sectionImage: "/images/blogs/cyberstrike/cs3.png",
        imageCaption: "Image 3 : Inoubliable - V contemple l'immensité de l'exploration urbaine."
      },
      {
        subtitle: "🏗️ Un Système de Créativité Débridée (Emprise)",
        text: "Loin d'être un simple gadget, le pouvoir d'Emprise a surpris par sa profondeur. Assembler des plateformes pour traverser un ravin ou construire des machines de guerre pour vaincre des hordes d'ennemis reste un plaisir intact en 2026.",
        sectionImage: "/images/blogs/cyberstrike/cs4.png",
        imageCaption: "Image 4 : Créativité - V assemble un véhicule avec l'Emprise pour explorer les zones difficiles."
      },
      {
        subtitle: "❤️ Une Narration Émouvante",
        text: "L'arc narratif centré sur la loyauté et le sacrifice a marqué les esprits. La quête émotionnelle offre une dimension et une fin d'anthologie que beaucoup n'attendaient pas, notamment lors des interactions avec Alt.",
        sectionImage: "/images/blogs/cyberstrike/cs5.png",
        imageCaption: "Image 5 : Émotion - Alt contemple une projection de souvenirs, un moment fort de l'histoire."
      },
      {
        subtitle: "⚖️ Le Revers de la Médaille",
        text: "Tout n'est pas parfait. Avec le recul, certains manques se font sentir : des Badlands parfois vides, des boss inégaux et une immersion citoyenne qui pourrait encore progresser pour rivaliser avec les meilleurs RPG sandbox.",
        sectionImage: "/images/blogs/cyberstrike/cs6.png",
        imageCaption: "Image 6 : Bilan - V en pause dans un paysage industriel souterrain, un moment de réflexion sur Night City."
      },
      {
        subtitle: "🏁 Conclusion : Faut-il encore y jouer en 2026 ?",
        text: "Absolument. Que vous soyez un fan de la première heure ou un nouveau joueur, CyberStrike 2077 reste une référence. Le jeu a vieilli avec grâce et les patchs l'ont rendu plus stable que jamais. Serez-vous un mercenaire légendaire ou un inventeur de l'ombre ?",
        sectionImage: "/images/blogs/cyberstrike/cs7.png",
        imageCaption: "Image 7 : L'Héritage - Une image symbolique de la projection de l'aventure vers de nouveaux horizons."
      }
    ],
    verdict: "Un renouveau magistral. Night City est enfin la ville dont nous avions tous rêvé.",
    pros: ["Immersion urbaine totale", "Système de combat profond", "Narration émotionnelle poignante"],
    cons: ["Badlands un peu désertiques", "IA des citoyens perfectible", "Certains boss répétitifs"]
  },
  {
    id: 102,
    gameId: 7, 
    title: "🌅 Analyse : GTA VI – Le trailer qui a brisé Internet",
    date: "14 Novembre 2026",
    author: "Mamadou Ly", 
    category: "Analyse / Preview",
    image: "/images/blogs/gta6/gta6.jpg", 
    intro: "Le 4 décembre 2023 restera gravé dans l'histoire numérique. Le premier trailer de Grand Theft Auto VI n'a pas seulement fait du bruit : il a provoqué un séisme médiatique mondial, pulvérisant tous les records YouTube en moins de 24 heures.",
    sections: [
      {
        subtitle: "📈 Un Phénomène Pharaonique en Chiffres",
        text: "Le trailer a effacé les records : 100 millions de vues en moins de 30 heures. Rockstar confirme ici le plus grand monde ouvert jamais créé, une promesse d'immersion sans précédent qui redéfinit les attentes de toute l'industrie du jeu vidéo.",
        sectionImage: "/images/blogs/gta6/gta1.png",
        imageCaption: "Image 1 : Le plan large iconique de la plage de Vice City, symbole d'une nouvelle ère."
      },
      {
        subtitle: "🏝️ Vice City : L'Exploration Urbaine Inoubliable",
        text: "Leonida s'annonce comme une métropole tentaculaire où chaque quartier possède son caractère. La direction artistique capture l'essence de la Floride : soleils couchants dorés, néons criards et paysages contrastés, des plages de sable fin aux marécages boueux.",
        sectionImage: "/images/blogs/gta6/gta2.jpeg",
        imageCaption: "Image 2 : Vues larges de Vice City, illustrant la densité et la beauté organique du monde."
      },
      {
        subtitle: "🦾 Un Système de Créativité Débridée (Emprise)",
        text: "Rockstar introduit des éléments novateurs rappelant un système d'Emprise : planification méticuleuse des braquages, utilisation de drones et piratage. Cette créativité permet d'aborder chaque mission de manière unique, en exploitant les outils offerts par Leonida.",
        sectionImage: "/images/blogs/gta6/gta3.jpeg",
        imageCaption: "Image 3 : Lucia et son partenaire planifiant leurs méfaits, entre créativité et technologie."
      },
      {
        subtitle: "💔 Une Narration Émouvante : Mémoire et Sacrifice",
        text: "Le trailer se concentre sur Lucia, la première protagoniste féminine, et son partenaire. Rockstar semble avoir créé une narration cinématographique puissante, mêlant action intense et moments intimes, où le sacrifice pour le rêve américain sera au centre de l'histoire.",
        sectionImage: "/images/blogs/gta6/gta4.jpeg",
        imageCaption: "Image 4 : Lucia et son partenaire, un lien intime qui porte le poids d'une narration profonde."
      },
      {
        subtitle: "⚖️ Le Revers de la Médaille",
        text: "Tout n'est pas parfait : on redoute un monde extérieur parfois vide hors des zones urbaines et des combats de boss qui pourraient rester trop simples. Rockstar doit encore prouver que Leonida offrira de vraies interactions systémiques pour une immersion totale.",
        sectionImage: "/images/blogs/gta6/gta5.jpeg",
        imageCaption: "Image 5 : Lucia seule devant la fenêtre, illustrant l'incertitude et l'attente autour du titre."
      },
      {
        subtitle: "🏁 Conclusion : Faut-il encore y jouer en 2026 ?",
        text: "Absolument. GTA VI n'est plus seulement un jeu, c'est une promesse de liberté absolue. L'attente touche à sa fin et chaque détail du trailer suggère que Rockstar s'apprête une nouvelle fois à changer le monde du jeu vidéo."
      }
    ],
    verdict: "Une démonstration de force culturelle sans précédent. Le futur roi de l'Open-World arrive.",
    pros: ["Graphismes photo-réalistes", "Densité de population record", "Narration type Bonnie & Clyde"],
    cons: ["Exigences matérielles extrêmes", "Attente insoutenable", "Système de combat encore mystérieux"]
  },
{
    id: 103,
    gameId: 2, 
    title: "🛡️ Zelda: Tears of the Kingdom — Toujours au sommet ? Le Bilan, 3 ans après l’aventure céleste",
    date: "12 Mai 2026",
    author: "Nintendo News",
    category: "Rétrospective",
    image: "/images/blogs/zelda/zd1.png", 
    intro: "Il semble que c'était hier. Le 12 mai 2023, le monde entier plongeait dans les cieux d'Hyrule, redécouvrant une terre familière transfigurée par une catastrophe sans précédent. Aujourd'hui, en 2026, alors que la Nintendo Switch a un successeur officiel, il est temps de poser nos paravoiles et de regarder en arrière.",
    sections: [
      {
        subtitle: "📈 Un Succès Pharaonique en Chiffres",
        text: "Le succès ne s'est pas essoufflé. Fin 2025, le jeu a franchi le cap des 35 millions d'exemplaires vendus. Les joueurs ont passé plus d'un milliard d'heures à construire des véhicules insolites, prouvant que la créativité est le cœur battant de ce titre.",
        sectionImage: "/images/blogs/zelda/zd2.png",
        imageCaption: "Infographie : Un succès pharaonique qui confirme la place de Zelda comme pilier du catalogue."
      },
      {
        subtitle: "🪽 Ce qui a rendu l'aventure inoubliable",
        text: "Le monde d'Hyrule n'a jamais été aussi vaste. Passer des Îles Célestes aux Profondeurs en un seul plongeon procure toujours le même frisson. Le pouvoir d'Emprise a transformé chaque joueur en ingénieur, tandis que la quête des Larmes du Dragon a offert une fin d'anthologie.",
        sectionImage: "/images/blogs/zelda/zd3.png",
        imageCaption: "Inoubliable : Link contemple l'Exploration Triple Niveau depuis le ciel."
      },
       {
        subtitle: "L’Exploration Triple Niveau : Ciels, Surface et Abîmes",
        text: "Le monde d'Hyrule n'a jamais été aussi vaste et complexe. Passer des Îles Célestes aux Profondeurs en un seul plongeon procure toujours le même frisson qu'au premier jour. ",
      },
       {
        subtitle: "Un Système de Construction Révolutionnaire (Emprise)",
        text: " Loin d'être un simple gadget, le pouvoir d'Emprise a surpris par sa profondeur. Assembler des plateformes pour traverser un ravin, construire des véhicules pour explorer les Abîmes ou des machines de guerre pour vaincre des hordes d'ennemis reste un plaisir intact.",
        sectionImage: "/images/blogs/zelda/zd4.png", // Ton image de coucher du soleil
        imageCaption: "(Créativité : Link assemble un véhicule avec l'Emprise)"
      },
       {
        subtitle: "Une Narration Émouvante",
        text: " On ne peut pas parler de l'héritage du jeu sans mentionner l'histoire. La quête des Larmes du Dragon a marqué les esprits, offrant une dimension émotionnelle et une fin d'anthologie que beaucoup n'attendaient pas. ",
        sectionImage: "/images/blogs/zelda/zd5.png", // Ton image de coucher du soleil
        imageCaption: "(Émotion : Zelda contemple une projection de souvenirs)"
      },
      {
        subtitle: "⚖️ Le Revers de la Médaille : Ce qu'on attend pour la suite",
        text: "Tout n'était pas parfait. Avec le recul, un air de déjà-vu sur la carte d'Hyrule et des combats de boss parfois inégaux ont pu lasser certains fans. On note aussi que certaines zones du monde extérieur manquent parfois de vie malgré les points d'intérêt.",
        sectionImage: "/images/blogs/zelda/zd6.png",
        imageCaption: "Bilan : Link en pause dans un paysage désolé, symbole des réflexions pour le futur."
      },
     
      {
        subtitle: "🏁 Conclusion : Faut-il encore y jouer en 2026 ?",
        text: "Absolument. Que vous soyez un fan de la première heure ou un nouveau joueur, Tears of the Kingdom reste une référence. Le jeu a vieilli avec grâce et les patchs de performance l'ont rendu plus stable que jamais sur Nintendo Switch. Votre aventure pour sauver Hyrule vous attend toujours. Serez-vous un héros courageux ou un inventeur de génie ?",
        sectionImage: "/images/blogs/zelda/zd7.png",// Ici tu peux remettre une image finale si tu veux, ou laisser vide
        imageCaption: "Conclusion : Link contemple l'horizon de Hyrule, symbole d'une aventure inoubliable."
      }
    ],
    verdict: "Un monument du jeu vidéo qui restera dans les mémoires bien après 2026.",
    pros: ["Liberté de création totale", "Verticalité époustouflante", "Narration émotionnelle forte"],
    cons: ["Sensation de déjà-vu sur la carte", "Boss parfois trop simples", "Interface de gestion parfois lourde"]
  },
 {
    id: 104,
    gameId: 8, 
    title: "🌑 Elden Ring : Shadow of the Erdtree — Le retour du Roi des RPG ?",
    date: "9 Mars 2026",
    author: "Mamadou Ly", 
    category: "Analyse / Preview",
    image: "/images/blogs/elden/er0.jpg", 
    intro: "Deux ans après avoir conquis le monde, l'Entre-terre s'apprête à s'assombrir de nouveau. Shadow of the Erdtree n'est plus une simple rumeur : c'est une réalité qui promet de redéfinir ce qu'est un DLC de haute volée. Entre mystères mythologiques et défis insurmontables, l'excitation est à son comble.",
    sections: [
      {
        subtitle: "🌒 L'entrée dans l'Ombre",
        text: "Le voyage commence au palais de Mohgwyn, devant le cocon de Miquella. Ce bras flétri, baigné dans une lumière sépulcrale, est la porte d'entrée vers une dimension de souffrance et de beauté. Ce n'est pas un simple correctif, c'est l'aboutissement d'une refonte complète de la mythologie de l'Entre-terre.",
        sectionImage: "/images/blogs/elden/er1.jpeg",
        imageCaption: "Image 1 : L'entrée du DLC - Le bras flétri de Miquella sortant de son cocon."
      },
      {
        subtitle: "📈 Un Succès Pharaonique en Chiffres",
        text: "Elden Ring a franchi le cap historique de 25 millions de copies en 2025. Shadow of the Erdtree s'annonce comme la plus grande extension jamais créée par FromSoftware. Avec plus de 800 millions de boss déjà vaincus par la communauté, cette nouvelle ère de défis promet de battre tous les records d'engagement.",
        sectionImage: "/images/blogs/elden/er2.jpeg",
        imageCaption: "Image 2 : Infographie - La puissance culturelle d'Elden Ring résumée en chiffres clés."
      },
      {
        subtitle: "🪽 Ce qui a rendu l'aventure inoubliable",
        text: "La 'Terre d'Ombre' est un terrain de jeu inédit sous un Arbre-Monde assombri et tordu. La direction artistique sublime capture l'essence du crépuscule mélancolique. Le niveau de détail, des reflets sur l'eau aux textures des armures, laisse présager un monde ouvert plus immersif que jamais.",
        sectionImage: "/images/blogs/elden/er3.jpeg",
        imageCaption: "Image 3 : La Terre d'Ombre - Une exploration entre mélancolie et grandeur sous l'Arbre-Monde."
      },
      {
        subtitle: "🪄 Une Narration Émouvante : Mémoire et Sacrifice",
        text: "Au-delà de l'action, le DLC explore des thématiques de mémoire et de sacrifice. Le contact de Miquella et son flétrissement suggèrent une relation complexe et poignante. Chaque rencontre avec les nouveaux PNJ, comme le mystérieux Messmer, promet une expérience cinématographique qui marquera les esprits.",
        sectionImage: "/images/blogs/elden/er4.jpeg",
        imageCaption: "Image 4 : Sacrifice rituel - Un nouveau PNJ mystérieux portant le poids de la narration."
      },
      {
        subtitle: "🏁 Conclusion : Faut-il encore y jouer en 2026 ?",
        text: "Absolument. Elden Ring reste une référence absolue du RPG. L'attente autour de Shadow of the Erdtree montre que le trône du roi n'est pas prêt d'être cédé. Préparez-vous à une aventure où la mémoire de chaque personnage et leur sacrifice pour l'Ordre d'Or résonneront longtemps en vous.",
        sectionImage: "/images/blogs/elden/er5.jpeg",
        imageCaption: "Image 5 : L'attente - Miquella seule face à l'horizon, illustrant l'incertitude et l'excitation autour des grands titres de 2026."
      }
    ],
    verdict: "L'extension ultime pour le jeu de la décennie. Indispensable.",
    pros: ["Direction artistique magistrale", "Lore d'une profondeur infinie", "Nouveaux types d'armes innovants"],
    cons: ["Difficulté extrêmement punitive", "Accès au DLC complexe pour les nouveaux", "Certaines zones très sombres"]
  },
  {
    id: 105,
    gameId: 4, // ID de Hogwarts Legacy dans games.js
    title: "Hogwarts Legacy : Le Bilan, 3 ans après l’ouverture des portes de Poudlard",
    date: "9 Mars 2026",
    author: "Warner News",
    category: "Rétrospective",
    image: "/images/blogs/hl/hl1.png", // Image principale de l'article
    intro: "Il semble que c'était hier. Le 10 février 2023, le monde entier découvrait les couloirs de Poudlard au XIXe siècle. Aujourd'hui, en 2026, alors que les rumeurs sur une suite se précisent et que la série HBO pointe le bout de sa baguette, il est temps de poser nos valises et de regarder en arrière. Hogwarts Legacy n'a pas seulement été un jeu vidéo ; c'est devenu un phénomène culturel.",
    sections: [
      {
        subtitle: "🪄 Ce qui a rendu l'aventure inoubliable",
        text: "Si le jeu est toujours aussi populaire en 2026, c'est grâce à cette recette magique qui mélange nostalgie et modernité. L'entrée dans le château reste un moment fort, que nous avons voulu immortaliser.",
        sectionImage: "/images/blogs/hl/hl1.png",
        imageCaption: "Image 1 : L'Entrée dans la Magie - La première fois que l'on pousse les portes de la Grande Salle."
      },
      {
        subtitle: "⚔️ Maîtrise des Sorts et Combat Dynamique",
        text: "Loin d'être un simple 'jeu pour fans', le gameplay a surpris par sa profondeur. Le système de duel, avec sa parade active et ses enchaînements, reste un exemple de fluidité dans le genre action-RPG, trois ans plus tard.",
        sectionImage: "/images/blogs/hl/hl2.png",
        imageCaption: "Image 2 : Maîtrise des Sorts - Un sorcier de Serpentard défie une armure animée."
      },
      {
        subtitle: "🌿 La Salle sur Demande : Votre Sanctuaire Personnel",
        text: "Si le combat était intense, le jeu offrait aussi de vrais moments de création. La Salle sur Demande n'était pas un simple hub, mais un espace entièrement personnalisable où la botanique et l'alchimie prenaient vie. C'est ici que de nombreux joueurs ont passé des heures à peaufiner leur havre de paix.",
        sectionImage: "/images/blogs/hl/hl3.png",
        imageCaption: "Image 3 : Votre Sanctuaire Personnel - Une vue de la Salle sur Demande."
      },
      {
        subtitle: "🦅 L'Exploration Libre des Hautes Terres",
        text: "Une fois les bases maîtrisées, c'est l'immensité du monde extérieur qui s'offrait à nous. Survoler la vallée, découvrir des hameaux oubliés et admirer le château de Poudlard depuis les sommets environnants reste l'une des expériences les plus marquantes du jeu.",
        sectionImage: "/images/blogs/hl/hl4.png",
        imageCaption: "Image 4 : L'Exploration Libre - Un panorama majestueux de la vallée de Poudlard."
      },
      {
        subtitle: "🚀 Conclusion : Un Avenir Radieux (Hogwarts Legacy 2)",
        text: "Après ce tour d'horizon, une chose est sûre : Hogwarts Legacy a posé des bases extrêmement solides. Le succès ne se dément pas et l'avenir de la licence est assuré. Warner Bros. Games a confirmé que Hogwarts Legacy 2 est en développement actif. Pour conclure ce bilan, nous vous proposons une image symbolique de ce passage de témoin, projetant l'aventure vers de nouveaux horizons.",
        sectionImage: "/images/blogs/hl/hl5.png",
        imageCaption: "Image 5 : Le Futur de Poudlard - Une vue symbolique de l'avenir de la licence."
      }

    ],
    verdict: "Hogwarts Legacy a posé des bases extrêmement solides. Warner Bros. Games a confirmé que Hogwarts Legacy 2 est en développement actif. Le passage de témoin vers de nouveaux horizons est assuré.",
    pros: ["Immersion magique inégalée", "Système de combat très fluide", "Direction artistique fidèle"],
    cons: ["Quêtes secondaires répétitives", "Peu d'impact des choix moraux"]
  }
];